import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import TareaCard from './TareaCard';

export default function ColumnaKanban({ 
  columna, 
  tareas, 
  onEdit, 
  onDelete, 
  onViewDetail, 
  tareaExpandida, 
  onToggleExpand 
}) {
  const { setNodeRef } = useDroppable({
    id: columna.id,
  });

  return (
    <Card className={`${columna.color} border-2`}>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center justify-between">
          <span>{columna.titulo}</span>
          <Badge variant="secondary" className="ml-2">
            {tareas.length}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent ref={setNodeRef} className="min-h-[400px]">
        <SortableContext
          id={columna.id}
          items={tareas.map(t => t.id)}
          strategy={verticalListSortingStrategy}
        >
          <div>
            {tareas.map((tarea) => (
              <TareaCard
                key={tarea.id}
                tarea={tarea}
                onEdit={onEdit}
                onDelete={onDelete}
                onViewDetail={onViewDetail}
                isExpanded={tareaExpandida === tarea.id}
                onToggleExpand={onToggleExpand}
              />
            ))}
          </div>
        </SortableContext>
      </CardContent>
    </Card>
  );
}
